<template>
    <div id="ComponentModalRegistrarNecessidade">
        <div class="modal fade modern-modal" id="ModalRegistrarNecessidade" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-modern modal-grande">
                <div class="modal-content modal-modern-content border-0">

                    <!-- botão fechar -->
                    <button type="button"
                            class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                            :disabled="salvandoRegistro || salvandoItens"
                            data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <!-- header -->
                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>{{ tituloModal }}</h2>
                            <p v-if="etapa === 1">
                                Informe nome e descrição da necessidade.
                            </p>
                            <p v-else>
                                Selecione itens do catálogo e informe a quantidade.
                            </p>
                        </div>
                    </div>

                    <div class="modal-modern-body">

                        <!-- ========================= -->
                        <!-- ETAPA 1: REGISTRO -->
                        <!-- ========================= -->
                        <div v-if="etapa === 1" class="form-section">
                            <div class="form-group">
                                <label class="form-label">Nome da necessidade</label>
                                <input class="form-control"
                                       v-model.trim="registro.nmRegistroNecessidade"
                                       :class="{ 'border-danger': camposInvalidosRegistro.nome }"
placeholder="Ex: Necessidade - Obra XPTO"
                                       id="registro.nmRegistroNecessidade"
                                       maxlength="250"/>
                                <small v-if="camposInvalidosRegistro.nome" class="text-danger">
                                    Informe um nome.
                                </small>
                            </div>

                            <div class="form-group">
                                <label class="form-label">Descrição</label>
                                <textarea class="form-control form-textarea"
                                          rows="4"
                                          v-model.trim="registro.dsRegistroNecessidade"
placeholder="Detalhes adicionais..."
                                          id="registro.dsRegistroNecessidade"
                                          maxlength="1000"></textarea>
                            </div>
                            <!-- Adicionando Dropdown para seleção de setor -->
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-6">
                                        <label class="form-label">Setor</label>
                                        <v-select v-model="registro.idSetor"
                                                  :options="setores"
                                                  :clearable="true"
                                                  :loading="buscandoSetores"
                                                  placeholder="Selecione um setor"
                                                  :get-option-label="getLabelSetor"
                                                  :selectable="isSetorSelecionavel"
                                                  id="registro.idSetor"
                                                  >
                                            <template #no-options>
                                                <span>Não há setores disponíveis.</span>
                                            </template>
                                        </v-select>
                                    </div>
                                    <div class="col-6">
                                        <label class="form-label">Data Desejada</label>
                                        <input v-model="registro.dtDesejada"
                                               id="registro.dtDesejada"
                                               name="registro.dtDesejada"
                                               type="date" class="form-control"
                                               placeholder="Data Desejada" />
                                    </div>
                                </div>

                            </div>

                            <div class="form-actions">
                                <button class="modern-btn modern-btn-primary"
                                        type="button"
                                        :disabled="salvandoRegistro"
                                        @click="salvarRegistroEIrParaItens">
                                    <span v-if="salvandoRegistro" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    <span>{{ textoBotaoEtapa1 }}</span>
                                </button>
                            </div>
                        </div>

                        <!-- ========================= -->
                        <!-- ETAPA 2: ITENS -->
                        <!-- ========================= -->
                        <div v-else class="form-section">

                            <!-- seleção -->
                            <div class="form-grid form-grid-3">
                                <div class="form-group">
                                    <label class="form-label">Item do catálogo</label>
                                    <v-select v-model="itemCatalogoSelecionado"
                                              :options="listaItensCatalogo"
                                              :filterable="false"
                                              :clearable="true"
                                              :loading="buscandoCatalogo"
                                              @search="onSearchCatalogo"
                                              :get-option-label="getLabelCatalogo"
                                              placeholder="Digite ao menos 3 caracteres..."
                                              id="itemCatalogoSelecionado"
                                              >
                                        <template #no-options>
                                            <span>Digite ao menos 3 caracteres.</span>
                                        </template>
                                    </v-select>
                                    <small v-if="camposInvalidos.item" class="text-danger">
                                        Selecione um item válido.
                                    </small>
                                    <small v-if="mensagemDuplicado" class="text-warning">
                                        Esse item já foi adicionado.
                                    </small>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">Quantidade</label>
                                    <input type="number"
                                           class="form-control"
                                           v-model.number="qtdSelecionada"
                                           min="1"
                                           step="1"
                                           placeholder="0" 
                                           id="qtdSelecionada"
                                           />
                                    <small v-if="camposInvalidos.qtd" class="text-danger">
                                        Informe uma quantidade maior que 0.
                                    </small>
                                </div>

                                <div class="form-group">
                                    <label class="form-label">&nbsp;</label>
                                    <button class="modern-btn modern-btn-primary w-100"
                                            type="button"
                                            :disabled="!podeAdicionar"
                                            @click="adicionarNecessidade">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                                        </svg>
                                        Adicionar
                                    </button>
                                </div>
                            </div>

                            <!-- lista adicionada -->
                            <div v-if="necessidades.length" class="table-wrapper modern-table">
                                <table class="custom-table">
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th>Descrição</th>
                                            <th style="width: 160px;">Quantidade</th>
                                            <th style="width: 160px;">Valor Unitário</th>
                                            <th style="width: 160px;">Valor Total</th>
                                            <th style="width: 140px;">Valor sigiloso</th>
                                            <th style="width: 120px;">Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(n, idx) in necessidades" :key="n.idKey">
                                            <td data-label="Item">
                                                <div class="item-name">{{ n.nmItem }}</div>
                                                <div class="item-details">
                                                    {{ n.cdReferencia || n.cdItem || '-' }}
                                                    <span v-if="n.tpItem">• {{ n.tpItem }}</span>
                                                </div>
                                            </td>

                                            <td data-label="Descricao">
                                                {{ n.dsItem }}
                                            </td>

                                            <td data-label="Quantidade">
                                                <input type="number"
                                                       class="form-control form-control-sm"
                                                       :class="{ 'form-control-disabled': n.flUtilizado || salvandoItens }"
                                                       v-model.number="n.qtd"
                                                       min="1"
                                                       step="1"
                                                       :disabled="n.flUtilizado || salvandoItens"
                                                       :title="(n.flUtilizado || salvandoItens) ? 'Campo bloqueado — item já utilizado ou salvando' : ''"
                                                       @input="onQtdChange(n)" 
                                                       :id="idx+'_qtdItem'"
                                                       />

                                            </td>

                                            <td data-label="vlUnitarioItem">
                                                <div class="input-group input-group-sm" style="min-width:140px;">
                                                    <span class="input-group-text">R$</span>
                                                    <input type="text"
                                                           class="form-control"
                                                           :value="getDetailVlUnitFmt(n)"
                                                           @input="onInputDetailVlUnit(n, $event)" 
                                                           :id="idx+'_vlUnitarioItem'"
                                                           />
                                                </div>
                                            </td>

                                            <td data-label="vlTotalItem">
                                                <div class="input-group input-group-sm" style="min-width:140px;">
                                                    <span class="input-group-text">R$</span>
                                                    <input type="text"
                                                           class="form-control"
                                                           :value="getDetailVlTotalFmt(n)"
                                                           @input="onInputDetailVlTotal(n, $event)"
                                                           :id="idx+'_vlTotalItem'"
                                                           />
                                                </div>
                                            </td>

                                            <td data-label="Valor sigiloso" class="text-center">
                                                <div class="form-check d-flex justify-content-center">
                                                    <input type="checkbox"
                                                           class="form-check-input"
                                                           v-model="n.flValorSigiloso"
                                                           :disabled="n.flUtilizado || salvandoItens"
                                                           :id="idx+'_flValorSigiloso'" />
                                                </div>
                                            </td>

                                            <td data-label="Ações" class="text-center">
                                                <button class="action-btn action-btn-view mb-2"
                                                        type="button"
                                                        @click="editNecessidadeItem(idx)"
                                                        :title="n.flUtilizado
                                                            ? 'Item já utilizado — não pode remover'
                                                            : (removendoMap[n.idKey]
                                                            ? 'Removendo...'
                                                            : (salvandoItens ? 'Aguarde, salvando...' : 'Detalhes'))"
                                                        :disabled="n.flUtilizado || salvandoItens || removendoMap[n.idKey]">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                                    </svg>
                                                    <span class="action-text">Detalhes</span>
                                                </button>
                                                <button class="action-btn action-btn-delete"
                                                        type="button"
                                                        :class="{ 'action-btn-disabled': n.flUtilizado || salvandoItens || removendoMap[n.idKey] }"
                                                        @click="removerNecessidade(idx)"
                                                        :disabled="n.flUtilizado || salvandoItens || removendoMap[n.idKey]"
                                                        :title="n.flUtilizado
                                                                ? 'Item já utilizado — não pode remover'
                                                                : (removendoMap[n.idKey]
                                                                ? 'Removendo...'
                                                                : (salvandoItens ? 'Aguarde, salvando...' : 'Remover item'))">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                    </svg>
                                                    <span class="action-text">{{ removendoMap[n.idKey] ? 'Removendo...' : 'Remover' }}</span>
                                                </button>

                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div v-else class="empty-state">
                                <div class="empty-content">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>
                                    <h3 class="empty-title">Nenhum item adicionado</h3>
                                    <p class="empty-description">Selecione itens do catálogo e adicione-os à lista.</p>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- footer ações -->
                    <div class="modal-modern-footer mt-auto">
                        <div class="footer-actions">
                            <button v-if="etapa === 2"
                                    type="button"
                                    class="modern-btn modern-btn-warning btn-alterar-dados"
                                    title="Alterar dados do registro de necessidade"
                                    @click="voltarEtapa1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                                </svg>
                                Alterar dados
                            </button>
                            <button class="modern-btn modern-btn-secondary"
                                    type="button"
                                    @click="limparTudo"
                                    :disabled="(etapa === 2 && !necessidades.length) || salvandoRegistro || salvandoItens">
                                Limpar
                            </button>

                            <button v-if="etapa === 2"
                                    class="modern-btn modern-btn-success"
                                    type="button"
                                    @click="salvarItens"
                                    :disabled="!necessidadesValidas || salvandoItens">
                                <span v-if="salvandoItens" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                <span v-if="!salvandoItens">Salvar itens</span>
                                <span v-else>Salvando...</span>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="modal fade modern-modal" id="ModalRegistrarNecessidadeItem" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-modern modal-grande">
                <div class="modal-content modal-modern-content border-0">

                    <!-- botão fechar -->
                    <button type="button"
                            class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                            data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <!-- header -->
                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none">
                                <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>
                                Detalhes do Item
                            </h2>
                        </div>
                    </div>

                    <div class="modal-modern-body" v-if="editItem">

                        <!-- ========================= -->
                        <!--  DETALHE ITEM -->
                        <!-- ========================= -->
                        <div class="form-section">
                            <div class="form-group">
                                <div data-v-4d65074c="" class="item-name">{{editItem.nmItem}}</div>
                                <div data-v-4d65074c="" class="item-details"> {{editItem.cdItem}} <span data-v-4d65074c="">• {{editItem.tpItem}}</span></div>
                                <div v-if="editItem.dsItem">
                                    {{editItem.dsItem}}
                                </div>
                            </div>

                            <hr />

                            <div class="form-group">
                                <label class="form-label">
                                    Unidade Responsável
                                </label>
                                <v-select v-model="editItem.idUnidade"
                                          :options="unidades"
                                          :clearable="true"
                                          :loading="buscandoSetores"
                                          placeholder="Selecione uma Unidade"
                                          :get-option-label="getLabelUnidade"
                                          :selectable="isUnidadeSelecionavel"
                                          id="editItem.idUnidade"
                                          >
                                    <template #no-options>
                                        <span>Não há unidades disponíveis.</span>
                                    </template>
                                </v-select>
                            </div>

                            <div class="form-group">
                                <div class="row">
                                    <div class="col-4">
                                        <label class="form-label">Data Desejada</label>
                                        <input v-model="editItem.dtDesejada"
                                               name="editItem.dtDesejadaItem"
                                               type="date" class="form-control"
                                               placeholder="Data Desejada"
                                               id="editItem.dtDesejadaItem"
                                               />
                                    </div>
                                    <div class="col-4">
                                        <label class="form-label">Grau de Prioridade</label>
                                        <input type="text"
                                               class="form-control"
                                               v-model="editItem.dsGrauPrioridade"
                                               placeholder="ex: Alto, Médio e Baixo"
                                               maxlength="50"
                                               id="editItem.dsGrauPrioridade"
                                               />
                                    </div>
                                    <div class="col-4">
                                        <label class="form-label">
                                            Envolve postos de trabalho

                                        </label>
                                        <select 
                                                class="form-control form-section" 
                                                v-model="editItem.flEnvolvePostoTrabalho"
                                                id="editItem.flEnvolvePostoTrabalho"
                                                >
                                            <option value="null"> -- Selecione --</option>
                                            <option value="true">Sim</option>
                                            <option value="false">Não</option>
                                        </select>
                                    </div>
                                </div>
                                
                            </div>

                            <div class="form-group">
                                <div class="row">
                                    <div class="col-6">
                                        <label class="form-label">
                                            Número do processo de contratação
                                        </label>
                                        <input type="text"
                                               class="form-control"
                                               v-model="editItem.nrProcessoContratacao"
                                               placeholder=""
                                               maxlength="150" 
                                               id="editItem.nrProcessoContratacao"
                                               />
                                    </div>
                                    <div class="col-6">
                                        <label class="form-label">
                                            Vinculação a outras contratações
                                        </label>
                                        <input type="text"
                                               class="form-control"
                                               v-model="editItem.nrProcessoVinculacao"
                                               placeholder="" 
                                               maxlength="150"  
                                               id="editItem.nrProcessoVinculacao"
                                               />
                                    </div>
                                </div>
                                
                            </div>


                            <div class="form-group">
                                <label class="form-label">
                                    Justificativa da necessidade
                                </label>
                                <textarea class="form-control"
                                        v-model="editItem.dsJustificativa"
                                        maxlength="500"
                                        id="editItem.dsJustificativa"
                                          >
                                </textarea>
                            </div>

                        </div>

                    </div>

                    <!-- footer ações -->
                    <div class="modal-modern-footer mt-auto">
                        <div class="footer-actions">
                            <button type="button" class="modern-btn modern-btn-secondary" data-bs-dismiss="modal"> Cancelar </button>
                            <button
                                    class="modern-btn modern-btn-success"
                                    type="button"
                                    @click="salvarDetalheItem">
                                <span>Salvar Detalhes</span>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css'

    export default {
        name: 'ModalRegistrarNecessidade',
        components: { 'v-select': vSelect },
        props: {
            showModal: Boolean,
        },

        data() {
            return {
                myModal: null,
                myModalRegistrarNecessidadeItem: null,
                etapa: 1,
                salvandoRegistro: false,
                salvandoItens: false,
                registro: {
                    idRegistroNecessidade: 0,
                    nmRegistroNecessidade: '',
                    dsRegistroNecessidade: '',
                    idSetor: null,
                },
                setores: [],
                unidades: [],
                buscandoSetores: false,
                camposInvalidosSetor: false,
                camposInvalidosRegistro: { nome: false },
                itemCatalogoSelecionado: null,
                listaItensCatalogo: [],
                buscandoCatalogo: false,
                catalogoDebounce: null,
                qtdSelecionada: 1,
                necessidades: [], // { idKey, idItem, cdItem, cdReferencia, nmItem, tpItem, qtd }
                camposInvalidos: { item: false, qtd: false },
                mensagemDuplicado: false,
                mode: 'create',
                carregandoEdicao: false,
                editId: null,
                removendoMap: {},

                editItem: null,
                editIdItem: null,

            }
        },

        computed: {
            podeAdicionar() {
                if (this.etapa !== 2) return false
                if (!this.itemCatalogoSelecionado) return false

                const qtd = Number(this.qtdSelecionada || 0)
                if (!qtd || qtd <= 0) return false

                const id = this.getIdItem(this.itemCatalogoSelecionado)
                if (!id) return false

                return !this.jaExiste(id)
            },

            necessidadesValidas() {
                if (this.etapa !== 2) return false
                if (!this.necessidades.length) return false
                return this.necessidades.every(n => Number(n.qtd || 0) > 0)
            },
            isEdit() {
                return this.mode === 'edit' && Number(this.registro.idRegistroNecessidade || 0) > 0
            },

            tituloModal() {
                return this.isEdit ? 'Editar Necessidade' : 'Registrar Necessidades'
            },

            textoBotaoEtapa1() {
                if (this.salvandoRegistro) return 'Salvando...'
                return this.isEdit ? 'Salvar e ir para itens' : 'Salvar e adicionar itens'
            },
        },

        mounted() {
            this.resetWizard()
            this.mode = 'create'
            this.editId = null

            this.myModal = new window.bootstrap.Modal('#ModalRegistrarNecessidade')
            this.myModalRegistrarNecessidadeItem = new window.bootstrap.Modal('#ModalRegistrarNecessidadeItem')

            const modalEl = document.getElementById('ModalRegistrarNecessidade')
            if (modalEl) {
                modalEl.addEventListener('hidden.bs.modal', () => {
                    //this.resetWizard()
                    //this.mode = 'create'
                    //this.editId = null
                    //this.$emit('close')
                })
            }

            const modalElRegistrarNecessidadeItem = document.getElementById('ModalRegistrarNecessidadeItem')
            if (modalElRegistrarNecessidadeItem) {
                modalElRegistrarNecessidadeItem.addEventListener('hidden.bs.modal', () => {
                    this.resetWizardDetalhes()
                    this.fecharRegistrarNecessidadeItem();
                })
            }
        },

        watch: {
            showModal(v) {
                if (v) this.abrir()
            },

            itemCatalogoSelecionado() {
                this.mensagemDuplicado = false
                this.camposInvalidos.item = false
            },

            qtdSelecionada() {
                this.camposInvalidos.qtd = false
            },

            'registro.nmRegistroNecessidade'() {
                this.camposInvalidosRegistro.nome = false
            },
            'registro.idSetor'() {
                this.camposInvalidosSetor = false
            },

        },

        methods: {
           
            async getUsuarioConfiguracao() {
                try {
                    const res = await axios.get(`${urlApi}/UsuarioSetor/GetUsuarioConfiguracao`)
                    if (res.data?.success) {
                        this.setores = [{ idSetor: null, nmSetor: "Sem setor" }, ...(res.data.data?.setores || [])]
                    } else {
                        console.warn("Resposta sem sucesso")
                        this.setores = [{ idSetor: null, nmSetor: "Sem setor" }]
                    }
                } catch (err) {
                    console.error("Erro ao fazer requisição:", err)
                    avisoToast("Erro ao carregar setores!", "warning")
                    this.setores = [{ idSetor: null, nmSetor: "Sem setor" }]
                }
            },

            async getUnidades() {
                try {
                    const res = await axios.get(`${urlApi}/Unidade/Get`)
                    if (res.data?.success) {
                        this.unidades = [{ idUnidade: null, nmUnidade: "Sem unidade" }, ...(res.data.data?.rows || [])]
                    } else {
                        console.warn("Resposta sem sucesso")
                        this.unidades = [{ idUnidade: null, nmUnidade: "Sem unidade" }]
                    }
                } catch (err) {
                    console.error("Erro ao fazer requisição:", err)
                    avisoToast("Erro ao carregar unidades!", "warning")
                    this.unidades = [{ idUnidade: null, nmSetor: "Sem unidade" }]
                }
            },

            validarRegistro() {
                this.camposInvalidosRegistro.nome = !this.registro.nmRegistroNecessidade?.trim()

                const setor = this.registro.idSetor
                this.camposInvalidosSetor = !(setor && setor.idSetor !== null && setor.idSetor !== undefined)

                return !(this.camposInvalidosRegistro.nome || this.camposInvalidosSetor)
            },


            getLabelSetor(option) {
                return option.nmSetor;
            },

            getLabelUnidade(option) {
                return option.nmUnidade;
            },

            async salvarRegistroEIrParaItens() {
                if (!this.validarRegistro()) {
                    avisoErro('Preencha o nome da necessidade e selecione um setor.');
                    return;
                }

                this.salvandoRegistro = true;
                try {
                    const payload = {
                        DadosRegistroNecessidade: {
                            idRegistroNecessidade: this.registro.idRegistroNecessidade || 0,
                            idSetor: this.registro.idSetor?.idSetor ?? null,
                            nmRegistroNecessidade: this.registro.nmRegistroNecessidade,
                            dsRegistroNecessidade: this.registro.dsRegistroNecessidade,
                            dtDesejada: this.registro.dtDesejada,
                        },
                    }

                    const res = await axios.post(`${urlApi}/RegistroNecessidade/PostRegistroNecessidade`, payload);

                    if (!res.data?.success) {
                        avisoErro(res.data?.msg || 'Erro ao salvar registro de necessidade.');
                        return;
                    }

                    this.registro.idRegistroNecessidade = res.data.data
                    this.etapa = 2
                    this.$emit('saved', { idRegistroNecessidade: this.registro.idRegistroNecessidade })
                    avisoToast(this.isEdit ? 'Registro atualizado! Revise os itens.' : 'Registro criado! Agora adicione os itens.')
                } catch (e) {
                    console.error(e);
                    avisoErro('Erro ao salvar registro de necessidade.');
                } finally {
                    this.salvandoRegistro = false;
                }
            },

            resetWizard() {
                this.etapa = 1
                this.salvandoRegistro = false
                this.salvandoItens = false

                this.registro = {
                    idRegistroNecessidade: 0,
                    nmRegistroNecessidade: '',
                    dsRegistroNecessidade: '',
                    idSetor: null,
                }

                this.camposInvalidosRegistro = { nome: false }
                this.camposInvalidosSetor = false
                this.limparItensSomente()
            },

            limparItensSomente() {
                this.itemCatalogoSelecionado = null
                this.listaItensCatalogo = []
                this.buscandoCatalogo = false
                clearTimeout(this.catalogoDebounce)
                this.catalogoDebounce = null
                this.qtdSelecionada = 1

                this.necessidades = []
                this.camposInvalidos = { item: false, qtd: false }
                this.mensagemDuplicado = false
            },

            limparTudo() {
                this.resetWizard()
            },

            voltarEtapa1() {
                this.etapa = 1
            },

            onSearchCatalogo(search) {
                const termo = (search || '').trim()

                if (termo.length < 3) {
                    this.listaItensCatalogo = []
                    return
                }

                clearTimeout(this.catalogoDebounce)
                this.catalogoDebounce = setTimeout(async () => {
                    this.buscandoCatalogo = true
                    try {
                        const params = { take: 20, index: 0, dsTermo: termo }
                        const res = await axios.get(`${urlApi}/CadastroItem/Get`, { params })

                        if (res.data?.success) {
                            const rows = res.data.data?.rows || []
                            this.listaItensCatalogo = rows
                                .map(r => r.item || r.cadastroItem || r)
                                .filter(o => o && (o.idItem || o.cdItem || o.nmItem))
                        } else {
                            this.listaItensCatalogo = []
                        }
                    } catch (e) {
                        console.error(e)
                        this.listaItensCatalogo = []
                    } finally {
                        this.buscandoCatalogo = false
                    }
                }, 300)
            },

            getLabelCatalogo(opt) {
                const o = opt || {}
                return `${o.cdReferencia || o.cdItem || ''} - ${o.nmItem || ''}`.trim()
            },

            getIdItem(opt) {
                return opt?.idItem || null
            },

            jaExiste(idItem) {
                return this.necessidades.some(n => n.idItem === idItem)
            },

            adicionarNecessidade() {
                this.mensagemDuplicado = false

                this.camposInvalidos.item = !this.itemCatalogoSelecionado
                this.camposInvalidos.qtd = !(Number(this.qtdSelecionada || 0) > 0)

                if (this.camposInvalidos.item || this.camposInvalidos.qtd) {
                    avisoErro('Selecione um item e informe a quantidade.')
                    return
                }

                const idItem = this.getIdItem(this.itemCatalogoSelecionado)
                if (!idItem) {
                    avisoErro('Item inválido (sem idItem).')
                    return
                }

                if (this.jaExiste(idItem)) {
                    this.mensagemDuplicado = true
                    avisoErro('Esse item já foi adicionado.')
                    return
                }

                const o = this.itemCatalogoSelecionado
                this.necessidades.push({
                    idKey: `${idItem}-${Date.now()}`,
                    idItem: idItem,
                    cdItem: o.cdItem || null,
                    cdReferencia: o.cdReferencia || null,
                    nmItem: o.nmItem || '',
                    tpItem: o.tpItem || null,
                    qtd: Number(this.qtdSelecionada),

                    dsGrauPrioridade: null,
                    dsJustificativa: null,
                    idUnidade: null,
                    dtDesejada: null,
                    flEnvolvePostoTrabalho: null,
                    nrProcessoContratacao: null,
                    nrProcessoVinculacao: null,
                    flValorSigiloso: false,
                })

                this.itemCatalogoSelecionado = null
                this.qtdSelecionada = 1
                this.listaItensCatalogo = []
                this.camposInvalidos = { item: false, qtd: false }
            },

            editNecessidadeItem(idx) {
                const item = this.necessidades[idx]
                if (!item) return
                if (item?.flUtilizado) {
                    avisoToast('Esse item já foi utilizado e não pode ser editado.', 'warning')
                    return
                }


                this.editItem = item;
                this.editIdItem = idx;


                const idUnidadeNum = item.idUnidade

                if (idUnidadeNum === null || idUnidadeNum === undefined) {
                    this.editItem.idUnidade = null
                } else {
                    this.editItem.idUnidade = this.unidades.find(s => s.idUnidade === idUnidadeNum) || null
                }

                this.abrirRegistrarNecessidadeItem();
            },

            async removerNecessidade(idx) {
                const item = this.necessidades[idx]
                if (!item) return

                if (item?.flUtilizado) {
                    avisoToast('Esse item já foi utilizado e não pode ser removido.', 'warning')
                    return
                }

                const idRegItem = Number(item.idRegistroNecessidadeItem || 0)
                if (!idRegItem) {
                    this.necessidades.splice(idx, 1)
                    return
                }

                this.$set(this.removendoMap, item.idKey, true)

                try {
                    const payload = { idRegistroNecessidadeItem: idRegItem }

                    const res = await axios.post(`${urlApi}/RegistroNecessidade/DeleteRegistroNecessidadeItem`, payload)

                    if (!res.data?.success) {
                        avisoErro(res.data?.msg || 'Erro ao remover item.')
                        return
                    }

                    this.necessidades.splice(idx, 1)
                    avisoToast('Item removido com sucesso!')
                } catch (e) {
                    console.error(e)
                    avisoErro('Erro ao remover item.')
                } finally {
                    this.$delete(this.removendoMap, item.idKey)
                }
            },

            isSetorSelecionavel(option) {
                return option && option.idSetor !== null && option.idSetor !== undefined
            },

            isUnidadeSelecionavel(option) {
                return option && option.idUnidade !== null && option.idUnidade !== undefined
            },

            async salvarItens() {
                if (!this.registro.idRegistroNecessidade) {
                    avisoErro('Registro de necessidade ainda não foi criado.')
                    this.etapa = 1
                    return
                }

                if (!this.necessidadesValidas) {
                    avisoErro('Verifique os itens/quantidades.')
                    return
                }

                this.salvandoItens = true
                try {
                    const idRegistro = this.registro.idRegistroNecessidade

                    for (const n of this.necessidades) {
                        const payloadItem = {
                            DadosRegistroNecessidadeItem: {
                                idRegistroNecessidadeItem: n.idRegistroNecessidadeItem || 0,
                                idRegistroNecessidade: idRegistro,
                                idSetor: this.registro.idSetor?.idSetor ?? null,
                                idItem: n.idItem,
                                qtdItem: n.qtd,
                                flUtilizado: n.flUtilizado ?? false,
                                vlUnitarioItem: n.vlUnitarioItem,
                                vlTotalItem: n.vlTotalItem,
                                flValorSigiloso: !!n.flValorSigiloso,
                                dsGrauPrioridade: n.dsGrauPrioridade,
                                dsJustificativa: n.dsJustificativa,

                                idUnidade: n.idUnidade,
                                dtDesejada: n.dtDesejada,
                                flEnvolvePostoTrabalho: (n.flEnvolvePostoTrabalho == 'null' ? null : (n.flEnvolvePostoTrabalho == 'true')),
                                nrProcessoContratacao: n.nrProcessoContratacao,
                                nrProcessoVinculacao: n.nrProcessoVinculacao,

                            },
                        }

                        const res = await axios.post(
                            `${urlApi}/RegistroNecessidade/PostRegistroNecessidadeItem`,
                            payloadItem
                        )

                        if (!res.data?.success) {
                            avisoErro(res.data?.msg || `Erro ao salvar item: ${n.nmItem}`)
                            return
                        }
                    }

                    avisoToast('Itens salvos com sucesso!')
                    this.myModal.hide()
                    this.$emit('saved', { idRegistroNecessidade: idRegistro })
                    this.resetWizard()
                } catch (e) {
                    console.error(e)
                    avisoErro('Erro ao salvar itens.')
                } finally {
                    this.salvandoItens = false
                }
            },

            abrir() {
                if (!this.myModal) {
                    this.myModal = new window.bootstrap.Modal('#ModalRegistrarNecessidade')
                }
                this.mode = 'create'
                this.editId = null

                this.myModal.show()
                this.resetWizard()
                this.getUsuarioConfiguracao()
                this.getUnidades()
            },

            fechar() {
                if (!this.myModal) {
                    this.myModal = new window.bootstrap.Modal('#ModalRegistrarNecessidade')
                }
                this.myModal.hide()
            },

            async abrirParaEdicao(id) {
                const rid = Number(id || 0)
                if (!rid) {
                    avisoToast('ID inválido para edição.', 'warning')
                    return
                }

                if (!this.myModal) {
                    this.myModal = new window.bootstrap.Modal('#ModalRegistrarNecessidade')
                }

                this.mode = 'edit'
                this.editId = rid

                this.myModal.show()
                this.resetWizard()

                this.carregandoEdicao = true
                try {
                    await this.getUsuarioConfiguracao()
                    await this.getUnidades()

                    await this.carregarRegistro(rid)
                    await this.carregarItens(rid)

                    this.etapa = this.necessidades.length ? 2 : 1
                } catch (e) {
                    console.error(e)
                    avisoErro('Erro ao carregar dados para edição.')
                } finally {
                    this.carregandoEdicao = false
                }
            },

            async carregarRegistro(idRegistroNecessidade) {
                const res = await axios.get(`${urlApi}/RegistroNecessidade/GetRegistroNecessidade/${idRegistroNecessidade}`)

                if (!res.data?.success) {
                    throw new Error(res.data?.msg || 'Falha ao carregar registro.')
                }

                const detalhe = res.data.data || {}
                const reg = detalhe.registroNecessidade || detalhe
                this.registro.idRegistroNecessidade = reg.idRegistroNecessidade || idRegistroNecessidade
                this.registro.nmRegistroNecessidade = reg.nmRegistroNecessidade || ''
                this.registro.dsRegistroNecessidade = reg.dsRegistroNecessidade || ''
                this.registro.dtDesejada = (reg.dtDesejada != null ? reg.dtDesejada.split('T')[0] || null : null)

                const idSetorNum = reg.idSetor

                if (idSetorNum === null || idSetorNum === undefined) {
                    this.registro.idSetor = null
                } else {
                    this.registro.idSetor = this.setores.find(s => s.idSetor === idSetorNum) || null
                }

            },

            async carregarItens(idRegistroNecessidade) {
                const res = await axios.get(`${urlApi}/RegistroNecessidade/GetRegistroNecessidadeItemDetalhado`, {
                    params: { idRegistroNecessidade }
                })


                if (!res.data?.success) {
                    throw new Error(res.data?.msg || 'Falha ao carregar itens.')
                }

                const grid = res.data.data
                const rows = grid?.rows || grid || []
                const arr = Array.isArray(rows) ? rows : []

                const norm = arr.map(x => x.registroNecessidadeItem || x)

                this.necessidades = norm.map(it => {
                    const idItem = it.idItem ?? null
                    const idRegItem = it.idRegistroNecessidadeItem ?? 0
                    const qtd = Number(it.qtdItem ?? it.qtd ?? 0)

                    return {
                        idKey: `${idRegItem || idItem}-${Date.now()}-${Math.random()}`,
                        idRegistroNecessidadeItem: idRegItem,
                        idItem,
                        cdItem: it.cdItem || null,
                        cdReferencia: it.cdReferencia || null,
                        nmItem: it.nmItem || (idItem ? `Item ${idItem}` : ''),
                        dsItem: it.dsItem || null,
                        tpItem: it.tpItem || null,
                        qtd,
                        flUtilizado: !!it.flUtilizado,
                        flAtivo: it.flAtivo !== undefined ? !!it.flAtivo : true,
                        vlUnitarioItem: it.vlUnitarioItem,
                        flValorSigiloso: !!it.flValorSigiloso,
                        vlUnitFmt: it.vlUnitarioItem == null ? null: it.vlUnitarioItem.toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }),
                        vlTotalItem: it.vlTotalItem,
                        vlTotalFmt: it.vlTotalItem == null ? null : it.vlTotalItem.toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }),
                        dsGrauPrioridade: it.dsGrauPrioridade || null,
                        dsJustificativa: it.dsJustificativa || null,
                        idUnidade: it.idUnidade || null,
                        dtDesejada: (it.dtDesejada != null ? it.dtDesejada.split('T')[0] || null : null),
                        flEnvolvePostoTrabalho: (it.flEnvolvePostoTrabalho == null ? null : (""+it.flEnvolvePostoTrabalho ) ) ,
                        nrProcessoContratacao: it.nrProcessoContratacao || null,
                        nrProcessoVinculacao: it.nrProcessoVinculacao || null,

                    }
                })
            },

            onQtdChange(elm) {
                var qtd = Number(elm.qtd) | 0
                var v = elm.vlUnitarioItem | 0

                if (v == 0)
                    return

                elm.vlTotalItem = v * qtd;
                elm.vlTotalFmt = elm.vlTotalItem.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            },

            getDetailVlUnitFmt(elm) {
                return elm.vlUnitFmt;
            },

            onInputDetailVlUnit(elm, event) {
                const digits = (event.target.value || '').replace(/\D/g, '')
                const num = (parseInt(digits || '0', 10) / 100)
                const v = isNaN(num) ? 0 : num

                elm.vlUnitarioItem = v;
                elm.vlUnitFmt = elm.vlUnitarioItem.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

                var qtd = Number(elm.qtd) | 0
                elm.vlTotalItem = elm.vlUnitarioItem * qtd;
                elm.vlTotalFmt = elm.vlTotalItem.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            },


            getDetailVlTotalFmt(elm) {
                return elm.vlTotalFmt;
            },

            onInputDetailVlTotal(elm, event) {
                const digits = (event.target.value || '').replace(/\D/g, '')
                const num = (parseInt(digits || '0', 10) / 100)
                const v = isNaN(num) ? 0 : num

                elm.vlTotalItem = v;
                elm.vlTotalFmt = v.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            },

            abrirRegistrarNecessidadeItem() {
                this.myModal.hide()

                if (!this.myModalRegistrarNecessidadeItem) {
                    this.myModalRegistrarNecessidadeItem = new window.bootstrap.Modal('#ModalRegistrarNecessidadeItem')
                }

                this.myModalRegistrarNecessidadeItem.show()
            },

            fecharRegistrarNecessidadeItem() {
                if (!this.myModalRegistrarNecessidadeItem) {
                    this.myModalRegistrarNecessidadeItem = new window.bootstrap.Modal('#ModalRegistrarNecessidadeItem')
                }
                

                this.myModalRegistrarNecessidadeItem.hide()
                this.myModal.show()

                this.resetWizardDetalhes();
            },

            salvarDetalheItem() {
                this.editItem.idUnidade = this.editItem.idUnidade?.idUnidade ?? null;
                this.necessidades[this.editIdItem] = this.editItem;

                this.fecharRegistrarNecessidadeItem();
            },


            resetWizardDetalhes() {
                this.editIdItem = null;
                this.editItem = null;
            }
        },
    }
</script>

<style scoped>
    .modal-grande {
        width: 100% !important;
        max-width: calc(100vw - 40px) !important;
        margin: auto;
        margin-top: 20px;
        padding: 0 12px;
        
    }

    .modal-grande .modal-content{
        min-height: 95vh;
    }

    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .btn-close-modern {
        border-radius: 50% !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        background: #ffffff !important;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        box-shadow: 0 12px 30px rgba(15, 23, 42, 0.12);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .btn-close-modern:hover {
        transform: scale(1.07);
        box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
        border-color: transparent !important;
    }

    .btn-close-modern:hover svg {
        color: #ffffff;
    }

    .btn-md {
        z-index: 1001;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 24px;
        position: relative;
    }

    .modal-modern-header::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 32px;
        right: 32px;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
    }

    .header-icon {
        width: 64px;
        height: 64px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(16, 185, 129, 0.16) 0%, rgba(59, 130, 246, 0.16) 100%);
        color: #0f766e;
        flex-shrink: 0;
    }

    .header-text {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .header-text h2 {
        margin: 0;
        font-size: 24px;
        font-weight: 700;
        color: #0f172a;
    }

    .header-text p {
        margin: 0;
        color: #475569;
        font-size: 14px;
        max-width: 520px;
        line-height: 1.4;
    }

    .modal-modern-body {
        padding: 28px 32px 36px;
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .form-section {
        background: #ffffff;
        border-radius: 18px;
        border: 1px solid rgba(148, 163, 184, 0.2);
        box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
        padding: 28px 32px;
        display: flex;
        flex-direction: column;
        gap: 22px;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .form-label {
        font-weight: 600;
        color: #0f172a;
        font-size: 13px;
        text-transform: uppercase;
        letter-spacing: 0.3px;
    }

    .form-control {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        padding: 12px 14px;
        font-size: 14px;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
        background: #ffffff;
        color: #1f2937;
    }

    .form-control:focus {
        border-color: rgba(37, 99, 235, 0.6);
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
        outline: none;
    }

    .form-control.border-danger {
        border-color: #e87986 !important;
        box-shadow: 0 0 0 0.18rem rgba(196, 104, 110, 0.25);
    }

    /* Campo desabilitado — dica visual clara */
    .form-control.form-control-disabled,
    .form-control:disabled {
        background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%) !important;
        color: #64748b !important;
        border-color: #cbd5e1 !important;
        cursor: not-allowed !important;
        opacity: 0.9;
    }

    .form-control.form-control-disabled::placeholder,
    .form-control:disabled::placeholder {
        color: #94a3b8;
    }

    .form-textarea {
        min-height: 110px;
        resize: vertical;
    }

    .form-grid {
        display: grid;
        gap: 18px;
    }

    .form-grid-3 {
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    }

    .form-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        justify-content: flex-end;
        margin-top: 8px;
    }

    /* Tabela */
    .table-wrapper {
        margin-top: 8px;
        overflow: auto;
        max-height: 44vh;
    }

    .modern-table .custom-table {
        width: 100%;
        border-collapse: collapse;
        border-radius: 16px;
        overflow: hidden;
        border: 1px solid rgba(148, 163, 184, 0.2);
    }

    .modern-table .custom-table thead {
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    }

    .modern-table .custom-table th,
    .modern-table .custom-table td {
        padding: 14px 18px;
        border-bottom: 1px solid rgba(148, 163, 184, 0.16);
        font-size: 14px;
        color: #1e293b;
    }

    .modern-table .custom-table th {
        font-weight: 700;
        text-transform: uppercase;
        font-size: 12px;
        letter-spacing: 0.45px;
    }

    .modern-table .custom-table tbody tr:hover {
        background: rgba(59, 130, 246, 0.08);
    }

    .item-name {
        font-weight: 600;
        color: #0f172a;
        font-size: 14px;
        margin-bottom: 4px;
    }

    .item-details {
        font-size: 13px;
        color: #64748b;
    }

    /* Botões de Ação */
    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 14px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 13px;
        border: 2px solid transparent;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        background: #f8fafc;
        color: #1f2937;
    }

    .action-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
    }

    .action-btn-view {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        border-color: transparent;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
    }

        .action-btn-view:hover {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
        }

    .action-btn-delete {
        background: rgba(248, 113, 113, 0.12);
        color: #b91c1c;
        border-color: rgba(248, 113, 113, 0.35);
    }

    .action-btn-delete:hover {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        color: #ffffff;
        border-color: transparent;
    }

    /* Botão remover desabilitado — dica visual clara */
    .action-btn.action-btn-disabled,
    .action-btn:disabled {
        background: #e2e8f0 !important;
        color: #94a3b8 !important;
        border-color: #cbd5e1 !important;
        cursor: not-allowed !important;
        transform: none !important;
        opacity: 0.75;
    }

    .action-btn.action-btn-disabled:hover,
    .action-btn:disabled:hover {
        background: #e2e8f0 !important;
        color: #94a3b8 !important;
        border-color: #cbd5e1 !important;
        transform: none !important;
        box-shadow: none !important;
    }

    .action-text {
        font-size: 13px;
    }

    /* Empty State */
    .empty-state {
        text-align: center;
        padding: 48px 20px;
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        border-radius: 16px;
        border: 1px dashed rgba(148, 163, 184, 0.3);
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }

    .empty-icon {
        color: #cbd5e1;
        margin-bottom: 8px;
    }

    .empty-title {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        color: #0f172a;
    }

    .empty-description {
        margin: 0;
        font-size: 14px;
        color: #64748b;
    }

    /* Botões Modernos */
    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 12px 22px;
        border-radius: 14px;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        border: none;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        box-shadow: 0 8px 22px rgba(15, 23, 42, 0.12);
        color: #ffffff;
    }

    .modern-btn:hover {
        transform: translateY(-2px);
    }

    .modern-btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
    }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    }

    .modern-btn-success {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    }

    .modern-btn-secondary {
        background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
    }

    .modern-btn-warning {
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        color: #fff;
    }
    .modern-btn-warning:hover {
        background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
        box-shadow: 0 8px 20px rgba(245, 158, 11, 0.35);
    }

    /* Footer */
    .modal-modern-footer {
        padding: 0 32px 32px;
    }

    .footer-actions {
        display: flex;
        justify-content: flex-end;
        gap: 12px;
        flex-wrap: wrap;
    }

    /* V-Select Styles */
    :deep(.v-select) {
        position: relative;
    }

    :deep(.v-select .vs__dropdown-toggle) {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        background: #ffffff;
        padding: 10px 14px;
        min-height: 48px;
        transition: all 0.2s ease;
    }

    :deep(.v-select .vs__dropdown-toggle:hover) {
        border-color: rgba(59, 130, 246, 0.4);
    }

    :deep(.v-select .vs__dropdown-toggle:focus-within) {
        border-color: rgba(37, 99, 235, 0.6);
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
    }

    :deep(.v-select .vs__search) {
        font-size: 14px;
        color: #1f2937;
        padding: 0;
        margin: 0;
        border: none;
        outline: none;
    }

    :deep(.v-select .vs__search::placeholder) {
        color: #94a3b8;
        font-size: 14px;
    }

    :deep(.v-select .vs__dropdown-menu) {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        box-shadow: 0 12px 32px rgba(15, 23, 42, 0.15);
        margin-top: 6px;
        background: #ffffff;
        max-height: 300px;
        overflow-y: auto;
        padding: 8px 0;
        z-index: 1060 !important;
    }

    :deep(.v-select .vs__dropdown-option) {
        padding: 12px 18px;
        color: #1f2937;
        font-size: 14px;
        transition: all 0.2s ease;
        cursor: pointer;
    }

    :deep(.v-select .vs__dropdown-option:hover) {
        background: rgba(59, 130, 246, 0.1);
        color: #2563eb;
    }

    :deep(.v-select .vs__dropdown-option--highlight) {
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.15) 0%, rgba(59, 130, 246, 0.1) 100%);
        color: #1d4ed8;
        font-weight: 600;
    }

    .modal-modern-body :deep(.v-select .vs__selected-options) {
        padding: 0;
    }

    .modal-modern-body :deep(.v-select .vs__selected) {
        font-size: 14px;
        line-height: 1.5;
        margin: 0;
        padding: 0;
        color: #1f2937;
    }

    .modal-modern-body :deep(.v-select .vs__actions) {
        padding: 0 0 0 8px;
    }

    .modal-modern-body :deep(.v-select .vs__clear) {
        fill: #94a3b8;
    }

    .modal-modern-body :deep(.v-select .vs__open-indicator) {
        fill: #64748b;
    }

    .modal-modern-body :deep(.v-select.vs--open .vs__dropdown-toggle) {
        border-color: rgba(37, 99, 235, 0.6);
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
    }

    /* Spinner */
    .spinner-border-sm {
        width: 1rem;
        height: 1rem;
        border-width: 0.15em;
    }

    /* Responsive */
    @media (max-width: 768px) {
        .modal-modern-header,
        .modal-modern-body,
        .modal-modern-footer {
            padding: 24px 20px;
        }

        .modal-modern-header {
            flex-direction: column;
            align-items: stretch;
            gap: 14px;
        }

        .modal-modern-header::after {
            left: 20px;
            right: 20px;
        }

        .header-icon {
            width: 56px;
            height: 56px;
        }

        .form-section {
            padding: 24px;
        }

        .form-grid-3 {
            grid-template-columns: 1fr;
        }

        .footer-actions {
            flex-direction: column;
            width: 100%;
        }

        .modern-btn {
            width: 100%;
        }

        .modern-table .custom-table,
        .modern-table .custom-table thead,
        .modern-table .custom-table tbody,
        .modern-table .custom-table th,
        .modern-table .custom-table td,
        .modern-table .custom-table tr {
            display: block;
            width: 100%;
        }

        .modern-table .custom-table thead {
            display: none;
        }

        .modern-table .custom-table tr {
            margin-bottom: 16px;
            border-radius: 14px;
            overflow: hidden;
            box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
        }

        .modern-table .custom-table td {
            border: none;
            border-bottom: 1px solid rgba(148, 163, 184, 0.15);
            padding: 14px 16px;
            text-align: left !important;
        }

        .modern-table .custom-table td:last-child {
            border-bottom: none;
        }

        .modern-table .custom-table td::before {
            content: attr(data-label);
            display: block;
            font-weight: 700;
            margin-bottom: 6px;
            text-transform: uppercase;
            color: #64748b;
            font-size: 12px;
        }

        .action-text {
            display: none;
        }
    }

    /* Dark Mode */
    [data-bs-theme="dark"] .modern-modal .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111826 100%) !important;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .modern-modal .modal-modern-header::after {
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.2), transparent);
    }

    [data-bs-theme="dark"] .modern-modal .header-icon {
        background: linear-gradient(135deg, rgba(16, 185, 129, 0.26) 0%, rgba(59, 130, 246, 0.26) 100%);
        color: #34d399;
    }

    [data-bs-theme="dark"] .modern-modal .header-text h2 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .modern-modal .header-text p {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .modern-modal .form-section {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(148, 163, 184, 0.15);
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5);
    }

    [data-bs-theme="dark"] .modern-modal .form-label {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modern-modal .form-control {
        background: rgba(15, 23, 42, 0.8);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modern-modal .form-control:focus {
        border-color: rgba(59, 130, 246, 0.6);
        box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
    }

    [data-bs-theme="dark"] .modern-modal .input-group-text {
        background-color: rgba(15, 23, 42, 0.8);
        border: 2px solid rgba(148, 163, 184, 0.2);
        border-right: none;
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .modern-modal .input-group:focus-within .input-group-text {
        border-color: rgba(59, 130, 246, 0.6);
        color: #cbd5e1;
    }

    [data-bs-theme="dark"] .modern-modal .form-control.form-control-disabled,
    [data-bs-theme="dark"] .modern-modal .form-control:disabled {
        background: rgba(30, 41, 59, 0.6) !important;
        color: #64748b !important;
        border-color: #475569 !important;
    }

    [data-bs-theme="dark"] .modern-btn-warning {
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        color: #fff;
    }
    [data-bs-theme="dark"] .modern-btn-warning:hover {
        background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
        box-shadow: 0 8px 20px rgba(245, 158, 11, 0.35);
    }

    [data-bs-theme="dark"] .modern-modal .modern-table .custom-table {
        border-color: rgba(148, 163, 184, 0.18);
    }

    [data-bs-theme="dark"] .modern-modal .modern-table .custom-table thead {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
    }

    [data-bs-theme="dark"] .modern-modal .modern-table .custom-table th,
    [data-bs-theme="dark"] .modern-modal .modern-table .custom-table td {
        color: #e2e8f0;
        border-color: rgba(148, 163, 184, 0.15);
    }

    [data-bs-theme="dark"] .modern-modal .modern-table .custom-table tbody tr:hover {
        background: rgba(59, 130, 246, 0.18);
    }

    [data-bs-theme="dark"] .action-btn.action-btn-disabled,
    [data-bs-theme="dark"] .action-btn:disabled {
        background: rgba(51, 65, 85, 0.8) !important;
        color: #64748b !important;
        border-color: #475569 !important;
    }

    [data-bs-theme="dark"] .action-btn.action-btn-disabled:hover,
    [data-bs-theme="dark"] .action-btn:disabled:hover {
        background: rgba(51, 65, 85, 0.8) !important;
        color: #64748b !important;
    }

    [data-bs-theme="dark"] .item-name {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .item-details {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .empty-state {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-color: rgba(148, 163, 184, 0.2);
    }

    [data-bs-theme="dark"] .empty-icon {
        color: #475569;
    }

    [data-bs-theme="dark"] .empty-title {
        color: #f9fafb;
    }

    [data-bs-theme="dark"] .empty-description {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__dropdown-toggle) {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__search) {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__search::placeholder) {
        color: #64748b;
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__selected) {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__no-options) {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__clear) {
        fill: #94a3b8;
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__open-indicator) {
        fill: #94a3b8;
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__dropdown-menu) {
        background: rgba(15, 23, 42, 0.98);
        border-color: rgba(148, 163, 184, 0.25);
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5);
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__dropdown-option) {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__dropdown-option:hover) {
        background: rgba(59, 130, 246, 0.2);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select .vs__dropdown-option--highlight) {
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.3) 0%, rgba(59, 130, 246, 0.2) 100%);
        color: #93c5fd;
    }

    [data-bs-theme="dark"] .modal-modern-body :deep(.v-select.vs--open .vs__dropdown-toggle) {
        border-color: #3b82f6;
        background: rgba(15, 23, 42, 0.95);
        box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
    }

    [data-bs-theme="dark"] .btn-close-modern {
        background: rgba(15, 23, 42, 0.9) !important;
        border-color: rgba(148, 163, 184, 0.25) !important;
    }

    [data-bs-theme="dark"] .btn-close-modern svg {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .btn-close-modern:hover {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
    }
</style>
